
    import './styles.scoped.css';
    export default {
  "radio-control": "awsui_radio-control_1v1hk_6ry0p_9",
  "outline": "awsui_outline_1v1hk_6ry0p_25",
  "styled-circle-border": "awsui_styled-circle-border_1v1hk_6ry0p_47",
  "styled-circle-disabled": "awsui_styled-circle-disabled_1v1hk_6ry0p_51",
  "styled-circle-readonly": "awsui_styled-circle-readonly_1v1hk_6ry0p_51",
  "styled-circle-fill": "awsui_styled-circle-fill_1v1hk_6ry0p_56",
  "styled-circle-checked": "awsui_styled-circle-checked_1v1hk_6ry0p_72",
  "awsui-radio-select": "awsui_awsui-radio-select_1v1hk_6ry0p_1"
};
  